// extracted by mini-css-extract-plugin
export default {"container":"AssetListLayout_container__S4d2A","header":"AssetListLayout_header__R-48c","title":"AssetListLayout_title__iB85A","more":"AssetListLayout_more__zNqr-"};